import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Calendar, ArrowRight } from 'lucide-react';

export default function ReferenceCard({ reference }) {
  const { title, description, image, location, year, slug } = reference;
  const imageUrl = Array.isArray(image) ? image[0] : image;
  const projectSlug = slug?.da || '';

  return (
    <Link 
      to={`/referencer/${projectSlug}`}
      className="bg-white border border-neutral-200/80 rounded-sm overflow-hidden shadow-md hover:shadow-xl hover:border-neutral-300 transition-all duration-300 flex flex-col group cursor-pointer"
    >
      {/* Image Container */}
      <div className="relative h-64 overflow-hidden bg-neutral-100">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-950/60 via-neutral-950/10 to-transparent" />
        
        {/* Meta Badges */}
        <div className="absolute bottom-4 left-4 right-4 flex flex-wrap gap-2">
          <span className="inline-flex items-center gap-1 bg-red-700 text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-sm">
            <MapPin size={10} />
            {location}
          </span>
          <span className="inline-flex items-center gap-1 bg-white/90 text-neutral-800 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-sm border border-neutral-200 shadow-sm">
            <Calendar size={10} />
            År {year}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-6 flex-grow flex flex-col justify-between">
        <div>
          <h3 className="text-lg font-bold text-neutral-950 group-hover:text-red-700 transition-colors mb-2">
            {title}
          </h3>
          <p className="text-neutral-600 text-sm leading-relaxed mb-4 line-clamp-3">
            {description}
          </p>
        </div>
        <div className="flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-red-700 mt-auto">
          <span>Se projekt</span>
          <ArrowRight size={12} className="group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </Link>
  );
}
